<template>
    <div class="bg-white">
      <Banner :imageSlides="imageSlides" v-if="imageSlides" />
      <BaseSpinner :size="4" class="py-5" v-if="loading" />
      <div v-else-if="!loading">
        <div class="row mx-2 mx-md-4">
          <div class="text-center fw-bold fs-2 py-5 d-flex align-items-center justify-content-center gap-4" data-cy="cases-list-header">
            <div class="charity-image position-relative d-flex justify-content-center align-items-center" >
              <img class="charity-image__hex position-absolute" :src="`${staticUrl}/static/icons/hex.svg`" />
              <img :src="charity_logo" alt="charity icon" class=" charity-image__charity position-relative" />
            </div>
            <div class="ms-3">{{ charity_name }}</div>
          </div>
          <CardBoard v-if="cases?.length" type="cases" :items="cases" />
          <div v-else class="text-center fw-bold fs-2 py-5">لا يوجد حالات</div>
        </div>
      </div>
      <div class="row mt-5" v-if="cases?.length">
        <Paginator :rows="9" :totalRecords="totalItemsCount" :first="firstItemIndex" @page="onPageChange($event)"></Paginator>
      </div>
      <div class="container" v-if="!loading">
          <MostafeedSection
            v-if="pageModel"
            :data="pageModel"
            class="tile-top"

            isCharityCasesPage
          ></MostafeedSection>
          </div>
    </div>
  </template>
  
<script>
  import CardBoard from "@/components/home/CardBoard";
  import CaseService from "@/services/case-service";
  import { useHead } from '@vueuse/head'
  import BaseSpinner from "@/components/layout/BaseSpinner";
  import { setLocalValue, getLocalValue, removeLocalValue } from "@/hooks/useLocalStorage";
  import MostafeedSection from "@/components/home/mostafeed.vue";
  import Banner from '@/components/home/Banner.vue';
  export default {
    name: "charity-cases-list",
    components: {CardBoard, BaseSpinner, MostafeedSection, Banner},
    inject: ['staticUrl'],
    setup() {
      useHead({
        title: 'مرضى الجمعية',
        meta: [
          {
            name: `description`,
            content: 'كن عونًا لهم بعطائك',
          },
        ],
      })
    },
    data() {
      return {
        cases: [],
        queryParams: {
          page: 1,
          page_size: 9,
          group: null,
          specialty: null
        },
        totalItemsCount: 9,
        loading: false,
        charityId: this.$route.params.id,
        charity_name: '',
        charity_logo: null,
        imageSlides: [],
        sliderPaused: false,
        pageModel: {},
      };
    },
    computed: {
      firstItemIndex() {
        return (this.queryParams.page - 1) * this.queryParams.page_size;
      },
    },
    mounted() {
      if (getLocalValue('selectedPage') && getLocalValue('selected_case_id')) {
      this.queryParams.page = getLocalValue('selectedPage');
      } else {
        removeLocalValue('selectedPage')
      }
      if (this.$route.query.group) {
        this.queryParams.group = this.$route.query.group;
      }
      if (this.$route.query.specialty) {
        this.queryParams.specialty = this.$route.query.specialty;
      }
      this.getPatientsAssociationCases()
      this.getCharityCases(this.queryParams)
    },
    methods: {
      getCharityCases(queryParams) {
        this.loading = true
        CaseService.getCharityCaseList(queryParams, this.charityId).then(({ data: { result } }) => {
          this.cases = result?.results;
          this.totalItemsCount = result?.total_objects;
          this.charity_name = result?.charity_name;
          this.charity_logo =  result?.charity_image;
        }).finally(() => {
          this.loading = false
        });
      },
      getPatientsAssociationCases() {
        this.loading = true
        CaseService.getPatientsAssociationCases(this.charityId).then(({ data: { result } }) => {
          this.imageSlides = result?.banner;
          this.pageModel = result;
        }).finally(() => {
          this.loading = false
        });
      },
      onPageChange(event) {
        this.queryParams.page = event.page + 1;
        setLocalValue('selectedPage', this.queryParams.page);
        this.getCharityCases(this.queryParams);
      },
    }
  };
</script>

<style lang="scss" scoped>

@import "../../styles/variables";
@import "@/styles/abstracts/mixins";

.charity-image {
  width: 80px;
  height: 90px;

  &__hex {
    opacity: .4;
    width: 100%;
    height: 100%;
    filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.2)); /* Add light shadow */
  }
  &__charity {
    max-width: 55px;
    max-height: 55px;
    z-index: 1;
  }
}

  ::v-deep(.p-paginator) {
    .p-paginator-first,
    .p-paginator-prev,
    .p-paginator-next,
    .p-paginator-last {
      transform: rotate(180deg);
    }
  }

</style>

